<div class="admin-container">
  <aside class="sidebar">
    <div class="logo" style="border-bottom: 1px solid #0000001c;">
      <div style="height: 50px;overflow: hidden;">
        <img src="assets/images/logo-2.png" alt="logo" style="height: 100%;object-fit: cover;">
      </div>
    </div>
    <nav>
      <a routerLink="/">
        <i class="fas fa-arrow-left"></i>
        Espace publique
      </a>
      <hr>
      <a routerLink="/admin/dashboard" routerLinkActive="active">
        <i class="fas fa-home"></i>
        Dashboard
      </a>
      <a *ngIf="hasAnyPermission(['view_celebrities'])" routerLink="/admin/celebrities" routerLinkActive="active">
        <i class="fas fa-star"></i>
        Célébrités
      </a>
      <a *ngIf="hasAnyPermission(['view_categories'])" routerLink="/admin/categories" routerLinkActive="active">
        <i class="fas fa-folder"></i>
        Catégories
      </a>
      <a *ngIf="hasAnyPermission(['view_fans'])" routerLink="/admin/fans" routerLinkActive="active">
        <i class="fas fa-users"></i>
        Fans
      </a>
      <a *ngIf="hasAnyPermission(['view_requests'])" routerLink="/admin/video-demands" routerLinkActive="active">
        <i class="fas fa-video"></i>
        Demandes
      </a>
      <a *ngIf="hasAnyPermission(['view_payments'])" routerLink="/admin/payments" routerLinkActive="active">
        <i class="fas fa-euro-sign"></i>
        Paiements
      </a>
      <a routerLink="/admin/contacts" routerLinkActive="active">
        <i class="fas fa-envelope"></i>
        Messages de contact
      </a>
      <!-- *ngIf="hasAnyPermission(['view_complaints'])" -->
      <a routerLink="/admin/complaints" routerLinkActive="active">
        <i class="fas fa-exclamation-circle"></i>
        Plaintes
      </a>
      <a *ngIf="hasAnyPermission(['view_tarifs'])" routerLink="/admin/tarifs" routerLinkActive="active">
        <i class="fas fa-tags"></i>
        Tarifs
      </a>
      <a routerLink="/admin/request-types" routerLinkActive="active">
        <i class="fas fa-list-alt"></i>
        Types de demandes
      </a>
      <a routerLink="/admin/complaint-types" routerLinkActive="active">
        <i class="fas fa-exclamation-triangle"></i>
        Types de plaintes
      </a>
      <a routerLink="/admin/streams" routerLinkActive="active">
        <i class="fas fa-video"></i>
        Streams
      </a>
      <a *ngIf="hasAnyPermission(['view_domains'])" routerLink="/admin/reports" routerLinkActive="active">
        <i class="fas fa-chart-bar"></i>
        Domaines
      </a>
      <!-- *ngIf="hasAnyPermission(['view_publications'])" -->
      <a routerLink="/admin/publications" routerLinkActive="active">
        <i class="fas fa-newspaper"></i>
        Publications
      </a>
      <a *ngIf="hasAnyPermission(['view_users'])" routerLink="/admin/users" routerLinkActive="active">
        <i class="fas fa-user-shield"></i>
        Utilisateurs
      </a>
      <hr>
      <!-- *ngIf="hasAnyPermission(['view_logs'])" -->
      <a routerLink="/admin/activity-logs" routerLinkActive="active">
        <i class="fas fa-history"></i>
        Historique des activités
      </a>
      <!-- <a *ngIf="hasAnyPermission(['view_settings'])" 
         routerLink="/admin/settings" 
         routerLinkActive="active">
        <i class="fas fa-cog"></i>
        Paramètres
      </a> -->
    </nav>
  </aside>

  <main class="main-content" style="padding-top: 100px;">
    <app-admin-header></app-admin-header>
    <router-outlet></router-outlet>
  </main>
</div>